module.exports = __webpack_public_path__ + "assets/images/4dc55843d78624905569c5d08aa58747.png";